import {Text} from '@dropbox/dig-components/typography';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine, ChevronRightLine} from '@dropbox/dig-icons/assets';
import {StatusChip} from 'components/DSYS/StatusChip';
import {calculateTimeAgo} from 'components/shared/TimeAgo';
import type {ReactNode} from 'react';
import {useState} from 'react';

import styles from './Roadmap.module.css';
import {RoadmapUpdateContent} from './RoadmapUpdateContent';

export interface RoadmapNodeUpdate {
  source: string;
  status: string;
  createdAt: string;
}

export const RoadmapNodeUpdateBlock = ({
  children,
  label,
  update,
}: {
  children: ReactNode;
  label: string;
  update: RoadmapNodeUpdate | null;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.roadmapNodeUpdateBlock}>
      <div className={styles.roadmapNodeUpdateRow}>
        <div className={styles.roadmapNodeUpdatePrimary}>{children}</div>
        {update ? (
          <button
            type="button"
            className={styles.roadmapNodeUpdateSummary}
            aria-label={`${isExpanded ? 'Collapse' : 'Expand'} update for ${label}`}
            aria-expanded={isExpanded}
            onClick={(event) => {
              event.stopPropagation();
              setIsExpanded((current) => !current);
            }}
          >
            <span className={styles.roadmapNodeUpdateStatus}>
              <StatusChip status={update.status} size="xsmall" includeArchived />
            </span>
            <Text size="small" color="faint" className={styles.roadmapNodeUpdateDate}>
              {calculateTimeAgo(update.createdAt, {compact: true})}
            </Text>
            <UIIcon
              src={isExpanded ? ChevronDownLine : ChevronRightLine}
              size="small"
              className={styles.roadmapNodeUpdateChevron}
            />
          </button>
        ) : null}
      </div>

      {update && isExpanded ? (
        <Text size="small" color="subtle" className={styles.roadmapNodeUpdateDetails}>
          <RoadmapUpdateContent value={update.source} />
        </Text>
      ) : null}
    </div>
  );
};
